import * as React from "react";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Typography } from "@mui/material";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
 
export default function DescriptionInputField({
  value: propValue = "",
  onChange,
  onClick,
  label,
  maxLength = 255,
  ...props
}) {
  const [value, setValue] = React.useState(propValue);
     const inputRef = React.useRef(null);
    const theme = useTheme();
    
  React.useEffect(() => {
    if (propValue !== value) {
      setValue(propValue);
    }
  }, [propValue]);
 
  const handleChange = (event) => {
    const inputValue = event.target.value;
 
    if (inputValue.length > maxLength) return;
    if (inputValue.trim().length === 0 && inputValue.length !== 0) return;
 
    setValue(inputValue);
    if (onChange) {
      onChange(inputValue);
    }
  };
 
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (onClick) {
        onClick(value);
      }
    }
  };
 
  return (
    <div>
      <Paper
        component="form"
        variant="outlined"
        onClick={() => inputRef.current?.focus()}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          width: "100%",
          height: "100px",
          border: (props.error !== undefined && props.error !== "") ? "1px solid #FE5050" : "1px solid #D9D9D9",
          borderRadius: "0.625rem",
          background: "transparent",
          opacity: 1,
          overflowY: "auto",
          cursor: "text",
        }}
      >
        <InputBase
          inputRef={inputRef} 
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          multiline
          sx={{
            ml: 1,
            flex: 1,
            color: "#242424 !important",
            "& textarea": {
              whiteSpace: "normal",
              textOverflow: "clip",
              display: "block",
              overflowY: "auto",
              [theme.breakpoints.down(1600)]: { fontSize: "0.95rem" },
              [theme.breakpoints.down(1366)]: { fontSize: "0.9rem" },
              "@media (max-width: 1280px)": { fontSize: "0.85rem" },
            },
            "&::placeholder": {
              color: "#242424 !important",
              [theme.breakpoints.down(1600)]: { fontSize: "0.95rem" },
              [theme.breakpoints.down(1366)]: { fontSize: "0.9rem" },
              "@media (max-width: 1280px)": { fontSize: "0.85rem" },
            },
          }}
          placeholder={label}
          className="input-placeholder"
          inputProps={{ "aria-label": label, maxLength }}
        />
      </Paper>
      {props.error && (
        <Box display="flex" alignItems="center" pt={0.5}>
          <Box pr={0.5} mt={0.5}>
            <ErrorIcon />
          </Box>
          <Box display="flex" alignItems="center">
            <Typography id="tags-error-message" className="helper-text">
              {props.error}
            </Typography>
          </Box>
        </Box>
      )}
  </div>
  );
}
 
 